import { Grid, Typography } from "@mui/material";
import { Profile } from "@readyfit-common/models";
import theme from "src/theme";
import useStyles from "./AthleteCard.styles";

interface AthleteCardProps {
  user: Profile;
  profileIconStyles?: string;
  nameStyles?: string;
}

const AthleteCard = ({
  user,
  profileIconStyles,
  nameStyles,
}: AthleteCardProps) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid container className={classes.nameContainer}>
        <Grid item className={`${classes.profileIcon} ${profileIconStyles}`}>
          <Typography
            variant="caption"
            textTransform={"uppercase"}
            color={"white"}
          >
            {user?.firstName?.[0]}
            {user?.lastName?.[0]}
          </Typography>
        </Grid>
        <Typography
          variant="caption"
          marginLeft={theme.spacing(1)}
          className={nameStyles}
        >
          {`${user?.firstName} ${user?.lastName}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AthleteCard;
